import React,{ useCallback, useState } from 'react';

//svg
import PlayerPlay from '../svg/PlayerPlay';
import PlayerPause from '../svg/PlayerPause';

//tools
import Vimeo from '@u-wave/react-vimeo';
import MediaQuery from 'react-responsive';
import {isIOS} from "react-device-detect";

import "./Player.scss";

const Player = ({title,vimeoId,panorama}) => {

    const [mobilePaused,setMobilePaused] = useState(true);
    const [singlePaused,setSinglePaused] = useState(false);
    const [paused,setPaused] = useState(false);

    const handlePlayerPlay = useCallback( () => {
        setMobilePaused(false);
        setSinglePaused(false);
        setPaused(false);
    },[setMobilePaused,setSinglePaused,setPaused])

    const handlePlayerPause = useCallback( () => {
        setMobilePaused(true);
        setSinglePaused(true);
        setPaused(true);
    },[setMobilePaused,setSinglePaused,setPaused])



    return (
        <div className={ panorama ? 'player-container panoramic' : 'player-container' }>

            {singlePaused &&
                <header><span>{title}</span></header>
            }

            <nav>
                <ul>
                    <li className="pause" onClick={handlePlayerPause} >
                        <PlayerPause />
                    </li>
                    <li className="play" onClick={handlePlayerPlay}>
                        <PlayerPlay />
                    </li>
                </ul>
            </nav>

            {isIOS ?
                <figure className="stage mobile ios">
                    <Vimeo
                        video={vimeoId}
                        paused={paused}
                        showByline={false}
                        showTitle={false}
                        className="vid"
                        autoplay={false}
                        autopause={true}
                        muted={false}
                    />
                </figure> :
                <>
                    <MediaQuery maxWidth={768}>
                        <div className="stage mobile">
                            <Vimeo
                                video={vimeoId}
                                paused={mobilePaused}
                                showByline={false}
                                showTitle={false}
                                className="vid"
                                autoplay={false}
                                autopause={true}
                            />
                        </div>
                    </MediaQuery>
                    <MediaQuery minWidth={769}>
                        <div className="stage">
                            <Vimeo
                                video={vimeoId}
                                paused={singlePaused}
                                showByline={false}
                                showTitle={false}
                                className="vid"
                                autoplay={true}
                                autopause={false}
                            />
                        </div>
                    </MediaQuery>
                </>
            }
        </div>
    );
};

export default Player;